import * as Yup from "yup";

const FormVetSchema = Yup.object().shape({
  email: Yup.string()
    .email("Informe um e-mail valido")
    .required("Informe seu e-mail"),
  nome: Yup.string().required("Informe seu nome"),
  telefone: Yup.string().required("Informe seu Celular"),
  estado: Yup.string().required("Informe seu Estado"),
  cidade: Yup.string().required("Informe sua Cidade"),
  especialidade: Yup.string().required("Informe sua especialidade"),
  crmv: Yup.string().required("Informe seu CRMV"),
});

export default FormVetSchema;
